import { render } from "./IntlTelInput.vue?vue&type=template&id=0722197c"
import script from "./IntlTelInput.vue?vue&type=script&lang=js"
export * from "./IntlTelInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__